import { useDispatch } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';

import { getBoards } from 'modules/boards/redux/boardActions';

export const useGetBoardsList = (societyId: string | undefined) => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchBoardsList = useCallback(async () => {
    if (!societyId) {
      return;
    }

    try {
      setIsLoading(true);
      await dispatch(getBoards(societyId));
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [societyId, dispatch]);

  useEffect(() => {
    fetchBoardsList();
  }, [fetchBoardsList]);

  return { isLoading, isError };
};
